import { Box, VStack, Image, Text } from '@chakra-ui/react';

function Login() {
  const handleSlackLogin = () => {
    const state = Math.random().toString(36).substring(7);
    sessionStorage.setItem('oauth_state', state);
    window.location.href = `/api/slack/authorize?state=${state}`;
  };

  return (
    <Box 
      as="main"
      minH="100vh" 
      minW="100vw"
      bg="gray.900" 
      display="flex" 
      alignItems="center" 
      justifyContent="center"
      margin={0}
      padding={0}
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
    >
      <VStack 
        spacing={8} 
        w="90%" 
        maxW="600px" 
        bg="gray.800" 
        p={12} 
        borderRadius="xl"
        boxShadow="2xl"
        m="auto"
      >
        <Image 
          src="/images/RTC-blue_logo.png" 
          alt="RTC Logo" 
          w="300px" 
          mb={4} 
        />
        <Text 
          color="white" 
          fontSize="2xl" 
          fontWeight="bold" 
          textAlign="center"
        >
          Welcome to RTC Resources
        </Text>
        <Box
          as="button"
          bg="purple.500"
          color="white"
          px={8}
          py={4}
          w="100%"
          maxW="300px"
          borderRadius="lg"
          display="flex"
          alignItems="center"
          justifyContent="center"
          _hover={{ 
            bg: 'purple.600',
            transform: 'translateY(-2px)',
            boxShadow: 'lg'
          }}
          transition="all 0.2s"
          onClick={handleSlackLogin}
        >
          <Image src="/images/slack_icon.png" h="24px" mr={3} />
          <Text fontSize="lg" fontWeight="semibold">Sign in with Slack</Text>
        </Box>
      </VStack>
    </Box>
  );
}

export default Login; 